'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onSave", "onClose"];
import PropTypes from 'prop-types';
import { CSSTransitionGroup as CSSTransition } from 'react-transition-group';
import EditLinkPopoverBodyLite from './EditLinkPopoverBodyLite';
import EditLinkPopoverBodyExpanded from './EditLinkPopoverBodyExpanded';
import withLinkState from './withLinkState';
import { PopoverBodyMode } from '../../constants/popover';
import { pick } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  renderLinkPopoverAlert: PropTypes.func
};
const renderPreview = (props, onEdit) => {
  const previewProps = pick(Object.keys(EditLinkPopoverBodyLite.propTypes), props);
  return /*#__PURE__*/_jsx(EditLinkPopoverBodyLite, Object.assign({}, previewProps, {
    onEdit: onEdit
  }));
};
const renderExpanded = (props, onSave, onClose) => {
  const expandedProps = pick(Object.keys(EditLinkPopoverBodyExpanded.propTypes), props);
  return /*#__PURE__*/_jsx(EditLinkPopoverBodyExpanded, Object.assign({}, expandedProps, {
    onSave: onSave,
    onClose: onClose
  }));
};
function EditLinkPopoverBodyV2(props) {
  const {
      mode,
      onModeChange,
      onSave,
      onClose
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleSave = () => {
    onModeChange();
    onSave();
  };
  const handleClose = () => {
    onModeChange();
    onClose();
  };
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-body",
    tabIndex: "-1",
    children: /*#__PURE__*/_jsx(CSSTransition, {
      className: "animated-transition",
      transitionName: "animated-popover",
      transitionEnterTimeout: 100,
      transitionLeaveTimeout: 100,
      children: mode === PopoverBodyMode.PREVIEW ? /*#__PURE__*/_jsx("div", {
        children: renderPreview(rest, () => onModeChange())
      }, 0) : /*#__PURE__*/_jsx("div", {
        children: renderExpanded(rest, handleSave, handleClose)
      }, 1)
    })
  });
}
EditLinkPopoverBodyV2.propTypes = propTypes;
EditLinkPopoverBodyV2.displayName = 'EditLinkPopoverBodyV2';
export default withLinkState(EditLinkPopoverBodyV2);